import "slick-carousel/slick/slick";

jQuery(document).ready(function () {
    var slidesToShowMD;

    var countSlides = jQuery('[data-slide="slide"]').length;

    if(countSlides === 1) {
        slidesToShowMD = 1
        jQuery(".video-carousel__slider").addClass('one-slide-only')
    } else if(countSlides === 2) {
        slidesToShowMD = 2
        jQuery(".video-carousel__slider").removeClass('one-slide-only')
    } else {
        slidesToShowMD = 3
        jQuery(".video-carousel__slider").removeClass('one-slide-only')
    }

    jQuery(".video-carousel__slider").on('init', function(event, slick){
        if(jQuery(".video-carousel__slider .slick-slide:not(.slick-cloned)").length <= 4){
            jQuery(".video-carousel .slick-arrow").addClass("hidden");
        }
    });

    jQuery(".video-carousel__slider").slick({
        mobileFirst: true,
        slidesToShow: 1,
        centerMode: true,
        arrows: false,
        prevArrow: jQuery(".video-carousel__prev"),
        nextArrow: jQuery(".video-carousel__next"),
        dots: true,
        centerPadding: "17%",
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    centerMode: true,
                    slidesToShow: slidesToShowMD,
                    centerPadding: "0",
                    arrows: false
                }
            },
            {
                breakpoint: 991,
                settings: {
                    centerMode: true,
                    slidesToShow: slidesToShowMD,
                    centerPadding: "0",
                    arrows: true
                }
            },
            {
                breakpoint: 1199,
                settings: {
                    centerMode: false,
                    slidesToShow: 4,
                    centerPadding: "0",
                    arrows: true
                }
            }
        ],
    })

    var isSliding = false;

    jQuery(".video-carousel__slider").on('beforeChange', function() {
        isSliding = true;
    });
    
    jQuery(".video-carousel__slider").on('afterChange', function() {
        isSliding = false;
    });

    jQuery(".video-carousel__slider").find(".video-carousel__slider-slide").on('click', function() {
        if (isSliding) {
            return;
        }

        const currentSlide = jQuery(this);
        const currentVideo = currentSlide.find('.video-carousel__slider-slide-video').get(0);
        const currentVideoOverlay = currentSlide.find('.video-carousel__slider-slide-video-wrapper');
    
        // Pause all other videos and remove the 'playing' class from their overlays
        jQuery('.video-carousel__slider-slide').not(currentSlide).each(function() {
            const otherSlide = jQuery(this);
            const otherVideo = jQuery(this).find('.video-carousel__slider-slide-video').get(0);
            const otherVideoOverlay = jQuery(this).find('.video-carousel__slider-slide-video-wrapper');
            
            if (otherVideo) {
                otherVideo.pause();
                otherVideo.currentTime = 0; 
                otherVideoOverlay.removeClass('playing');
                otherSlide.closest('.slick-slide').removeClass('keep-transition');
            }
        });
    
        // Toggle play/pause for the current video and manage the 'playing' class
        if (currentVideo) {
            if (currentVideo.paused) {
                currentVideo.play();
                currentVideoOverlay.addClass('playing');
                currentSlide.closest('.slick-slide').addClass('keep-transition')
            } else {
                currentVideo.pause();
                currentVideoOverlay.removeClass('playing');
                currentSlide.closest('.slick-slide').removeClass('keep-transition')
            }
        }
    });
});